import { createApp } from 'vue';
import App from './App.vue';
import { SentryService } from './Services/Sentry';
import { CoppiLocalisationPlugin, CoppiErrorReportingPlugin } from '@bookingkit/coppi';
import { bootstrapI18n, updateDocumentLanguage } from './Services/TranslationService';
import { DEFAULT_LOCALE } from '@/bootstrap/environment';
import { Locale } from '@/constants/locales';
import '@bookingkit/coppi/dist/style.css';
import '@/css/default-override.css';
import BookingkitApiService from '@/bootstrap/Factories/BookingkitApiFactory';
import { SelfService } from '@/Services/BKAPI/SelfService';
import { API_V4 } from '@/constants';

const initApplication = async () => {
  const BKSelfServiceApplication = createApp(App);
  BKSelfServiceApplication.use(CoppiLocalisationPlugin, {});
  BKSelfServiceApplication.config.errorHandler = err => {
    if (err instanceof Error) {
      SentryService.logError(err);
    } else {
      SentryService.logError(new Error(String(err)));
    }
  };
  const { default: router } = await import('@/router');
  const i18n = bootstrapI18n({
    locale: DEFAULT_LOCALE, // TODO for now its default - need to improve when we have data
  });
  updateDocumentLanguage(i18n.global.locale.value as Locale);

  const params = new URLSearchParams(window.location.search);
  const authToken = params.get('token') || undefined;
  if (params.has('token')) {
    params.delete('token');
    const cleanUrl = `${window.location.pathname}${params.toString() ? `?${params.toString()}` : ''}${window.location.hash}`;
    history.replaceState({}, '', cleanUrl);
  }

  const bookingkitApiService = BookingkitApiService({
    logger: SentryService,
    authToken,
  });
  BKSelfServiceApplication.provide<SelfService>(API_V4, bookingkitApiService.selfService);

  BKSelfServiceApplication.use(router);
  BKSelfServiceApplication.use(i18n);
  BKSelfServiceApplication.use(CoppiErrorReportingPlugin, { logException: SentryService.logError });

  BKSelfServiceApplication.mount('#app');
};

initApplication().catch(error => {
  SentryService.logError(error instanceof Error ? error : new Error(String(error)));
});
